import { c as _c } from "react/compiler-runtime";
import { useControlledSwr } from '@systemeio/util';
import { FUNNELS_API } from 'modules/funnels/api/funnels-api';
import { WebinarRegistrationInterface } from 'modules/funnels/funnel/types/webinar-registration-interface';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
interface OptionsInterface {
  shouldFetch?: boolean;
}
export function useWebinarRegistrationSettings(id, t0) {
  const $ = _c(9);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {
      shouldFetch: true
    } : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const options = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      method: RequestMethodsEnum.get
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    fetcher
  } = useFetch(t2);
  let t3;
  if ($[3] !== id || $[4] !== options) {
    t3 = () => {
      if (!id) {
        return;
      }
      if (!options.shouldFetch) {
        return;
      }
      return [`${FUNNELS_API}/steps/${id}/webinar-registration`, RequestModuleEnum.FunnelsStep];
    };
    $[3] = id;
    $[4] = options;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    data: webinarRegistrationSettings,
    mutate: mutateWebinarRegistrationSettings
  } = useControlledSwr(t3, fetcher);
  let t4;
  if ($[6] !== mutateWebinarRegistrationSettings || $[7] !== webinarRegistrationSettings) {
    t4 = {
      webinarRegistrationSettings,
      mutateWebinarRegistrationSettings
    };
    $[6] = mutateWebinarRegistrationSettings;
    $[7] = webinarRegistrationSettings;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}